import {ArchiveBoxIcon} from "@heroicons/react/24/outline";

const PaymentStatusLabel = ({paymentStatus, canShowUnpaid, className}) => {
    const supported = ['full', 'partial', 'package'];
    const isUnpaid = !paymentStatus;

    if (supported.indexOf(paymentStatus) < 0 && !(isUnpaid && canShowUnpaid)) {
        return null;
    }

    return (
        <span className={`tag bg-gray-500 ${className}`}>
            {isUnpaid && 'Unpaid'}
            {paymentStatus === 'full' && 'Paid'}
            {paymentStatus === 'partial' && 'Deposit'}
            {paymentStatus === 'package' && 'Package'}
        </span>
    )
}

export default PaymentStatusLabel;
